import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import EventsStore from '../../stores/EventsStore'
import { Button, Form, Grid, Header, Icon, Pagination, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Input from '../../components/Forms/Input'
import LoadingWrapper from '../../components/LoadingWrapper'

@inject('eventsStore')
@observer
class ArchivesScreen extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore).isRequired
  }

  constructor (props) {
    super(props)
    window.document.title = 'Archives'
  }

  componentDidMount () {
    const { eventsStore } = this.props
    eventsStore.clearFilters()
    eventsStore.loadAllArchive()
  }

  changePage = (page) => {
    const { eventsStore } = this.props
    eventsStore.changePage(page.activePage)
    eventsStore.loadAllArchive()
  }

  handleSendFilters = () => {
    const { eventsStore } = this.props
    eventsStore.sendFilters()
    eventsStore.loadAllArchive()
  }

  handleClearFilters = () => {
    const { eventsStore } = this.props
    eventsStore.clearFilters()
    eventsStore.loadAllArchive()
  }

  handleDownloadClick = (eventId) => {
    const { eventsStore } = this.props
    eventsStore.download(eventId)
  }

  render () {
    const { eventsStore } = this.props
    const { paging, events, isLoading } = eventsStore
    return (
      <>
        <Header as='h2'>Archives</Header>
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as='h3'>Filtrer par:</Header>
              <Form>
                <Form.Group widths='equal'>
                  <Input name='_tmpQuery.PK_Number' label='Code' store={eventsStore} />
                  <Input name='_tmpQuery.name' label='Nom Compagnie' store={eventsStore} />
                  <Input name='_tmpQuery.contact_name' label='Nom Contact' store={eventsStore} />
                  <Input name='_tmpQuery.address' label='Adresse' store={eventsStore} />
                </Form.Group>
                <Button primary onClick={this.handleSendFilters}>Filtrer</Button>
                <Button primary onClick={this.handleClearFilters}>Effacer</Button>
              </Form>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              {!!paging.Events && <Pagination
                onPageChange={(e, data) => this.changePage(data)}
                totalPages={paging.Events.pageCount}
                activePage={paging.Events.page}
                                  />}
              {!!events.length &&
                <Table celled>
                  <Table.Header key='header'>
                    <Table.Row>
                      <Table.HeaderCell>Technicien</Table.HeaderCell>
                      <Table.HeaderCell>Client</Table.HeaderCell>
                      <Table.HeaderCell>Adresse</Table.HeaderCell>
                      <Table.HeaderCell>Équipement</Table.HeaderCell>
                      <Table.HeaderCell>Date inspection</Table.HeaderCell>
                      <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body key='body'>
                    {events.map(event => {
                      return (
                        <Table.Row key={`event_${event.id}`}>
                          <Table.Cell>
                            {event.user.fullName}
                          </Table.Cell>
                          <Table.Cell>
                            {event.client.name}
                          </Table.Cell>
                          <Table.Cell>
                            {event.clients_addresses_equipment.clients_address.address.fullAddress}
                          </Table.Cell>
                          <Table.Cell>
                            {event.clients_addresses_equipment.equipment.name}
                          </Table.Cell>
                          <Table.Cell>
                            {moment(event.date_start).format('HH:mm DD-MM-YYYY')}
                          </Table.Cell>
                          <Table.Cell>
                            <Link to={`/archives/event/${event.id}`}>
                              <Icon
                                link
                                name='eye'
                              />
                            </Link>
                            <a target='_blank' href={`/api/archives/downloadpdf/${event.id}`} rel='noreferrer'>
                              <Icon name='certificate' link />
                            </a>
                            <Icon
                              link
                              name='download'
                              onClick={() => { this.handleDownloadClick(event.id) }}
                            />
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default ArchivesScreen
